module.exports = __webpack_public_path__ + "img/advantage2.c1687155.png";